interface IApiErrorItem {
  code?: string;
  description?: string;
  errorType?: string;
}

export const extractApiErrorMessage = (err: unknown, fallback: string): string => {
  const data = (err as any)?.response?.data;

  if (Array.isArray(data) && data.length > 0) {
    const messages = (data as IApiErrorItem[])
      .map((item) => item?.description)
      .filter((desc): desc is string => Boolean(desc && desc.trim()));
    if (messages.length > 0) return messages.join(" ");
  }

  if (data && typeof data === "object" && typeof data.description === "string" && data.description.trim()) {
    return data.description;
  }

  if (typeof data === "string" && data.trim()) {
    return data;
  }

  return fallback;
};
